export enum eSectionType {
    PEDESTRIAN = "pedestrian",
    VEHICLE = "vehicle",
    TRANSIT = "transit"
}